/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, {
  Dispatch,
  ReactElement,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'

import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  PageHeader,
  Radio,
  Row,
  Skeleton,
  Spin,
  Switch,
  Table,
} from 'antd'
import { SelectFieldAnt } from 'Components/Form'
import DateRange from 'Components/Form/DateRange'
import DateSelector from 'Components/Form/DateSelector'
import { SelectItemProps } from 'Components/Form/Select'
import ID_COMPONENTE from 'config/idComponente'
import Veiculos from 'Helpers/Veiculos'
import { Veiculo } from 'Models/cadastros'
import { IArmazem, IChegada, ISMSConfig } from 'Models/docas'
import IAtualizacaoPlaca from 'Models/docas/IAtualizacaoPlaca'
import IFormListaChegadaFilter from 'Models/docas/IFormListaChegadaFilter'
import moment from 'moment'
import env from 'react-dotenv'
import { useForm } from 'react-hook-form'
import WsDocasService from 'Services/WS_DOCAS'

import { DocasContext } from '../Context/context'

interface IProps {
  listaChegadas: IChegada[]
  setListaChegadas: Dispatch<SetStateAction<IChegada[]>>
}

const ModalListaChegadas = ({
  listaChegadas,
  setListaChegadas,
}: IProps): ReactElement => {
  const today: Date = new Date()
  const hookForm = useForm()
  const hookFormAtualizacaoPlaca = useForm()
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const [veiculos, setVeiculos] = useState<Veiculo[]>([])
  const [selectVeiculoItens, setSelectVeiculoItens] = useState<
    SelectItemProps[]
  >([])
  const [selectOpcoesChegadaVisualizada, setSelectOpcoesChegadaVisualizada] =
    useState<SelectItemProps[]>([])
  const [selectArmazemItens, setSelectArmazemItens] = useState<
    SelectItemProps[]
  >([])
  const [imagens, setImagens] = useState<string[]>()
  const [imagemUltimaChegada, setImagemUltimaChegada] = useState<string>()
  // const [tempoMsAtualizacao] = useState<number>(30000)
  // const [restauracaoImagemEmAndamento, setRestauracaoImagemEmAndamento] =
  //   useState<number>()
  const [configuracaoSMS, setConfiguracaoSMS] = useState<ISMSConfig>({
    ativo: true,
  })
  const [cssSwitchLabel] = useState<React.CSSProperties>({
    fontSize: '14px',
    paddingLeft: '8px',
    paddingRight: '2px',
  })
  const [carregandoImagens, setCarregandoImagens] = useState<boolean>(false)
  const [carregandoPesquisa, setCarregandoPesquisa] = useState<boolean>(false)

  const [segundosEntreRequisicoes] = useState<number>(
    window.parseInt(
      env.ATUALIZACAO_AUTOMATICA_MODAL_CHEGADAS_SEGUNDOS_ENTRE_REQUISICOES,
    ),
  )

  const [segundosNoPassadoParaDataInicial] = useState<number>(
    window.parseInt(
      env.ATUALIZACAO_AUTOMATICA_MODAL_CHEGADAS_SEGUNDOS_NO_PASSADO,
    ),
  )

  const [intervaloMaximoDias] = useState<number>(
    window.parseInt(env.MODAL_CHEGADAS_INTERVALO_MAXIMO_DIAS),
  )

  const [atualizacaoAutomatica, setAtualizacaoAutomatica] =
    useState<boolean>(false)
  const [carregandoAtualizacaoAutomatica, setCarregandoAtualizacaoAutomatica] =
    useState<boolean>(false)
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState<string>()
  const [idTimeout, setIdTimeout] = useState<number>()

  const [carregandoSMS, setCarregandoSMS] = useState<boolean>(false)
  const [veiculoAtualizado, setVeiculoAtualizado] = useState<Veiculo>()
  const [
    cdIntegracaoCameraPlacaParaAtualizar,
    setCdIntegracaoCameraPlacaParaAtualizar,
  ] = useState<number>()
  const [placaCadastrada, setPlacaCadastrada] = useState<string>()
  const [placaAtualizada, setPlacaAtualizada] = useState<string>()

  useEffect(() => {
    // const ultimaChegada =
    //   listaChegadas.length > 0 ? listaChegadas[0] : undefined

    // if (ultimaChegada) {
    //   const imagem = ultimaChegada.imagem

    //   if (imagem) {
    //     setImagens(imagem)
    //     setImagemUltimaChegada(imagem)
    //   }

    //   if (!ultimaChegada.visualizado) {
    //     visualizaChegada(ultimaChegada.cdIntegracaoCameraPlaca)
    //   }
    // }

    getVeiculos()
    getArmazens()
    getConfiguracaoSMS()
    getOpcoesChegadaVisualizada()

    // setInterval(() => {
    //   pesquisaListaChegadas()
    // }, tempoMsAtualizacao)

    const bolinhaBotaoSwitch = document.getElementsByClassName(
      'ant-switch-handle',
    )[0] as HTMLElement

    bolinhaBotaoSwitch.style.top = '6px'
  }, [])

  const getVeiculos = async () => {
    const veiculos: Veiculo[] = await Veiculos.get()
    setVeiculos(veiculos)
    setSelectVeiculoItens(
      await Veiculos.getListaSelecao(
        docasContext,
        setDocasContext,
        veiculos,
        true,
      ),
    )
  }

  const getArmazens = async () => {
    const { data } = await WsDocasService.armazem.getList(ID_COMPONENTE.DOCAS, {
      apenasAtivos: true,
    })

    if (data.items) {
      const selectArmazensData: SelectItemProps[] = data.items.map(
        (item: IArmazem) => {
          return {
            value: item.nomeArmazem,
            label: item.nomeArmazem,
          }
        },
      )

      setSelectArmazemItens(selectArmazensData)
    }
  }

  const getConfiguracaoSMS = async () => {
    setCarregandoSMS(true)

    const { data } = await WsDocasService.sms.getConfiguracao(
      ID_COMPONENTE.DOCAS,
    )

    if (data?.item) {
      setConfiguracaoSMS(data.item)
    } else {
      const { data } = await WsDocasService.sms.createConfiguracao(
        ID_COMPONENTE.DOCAS,
        configuracaoSMS,
      )

      if (data.statusCode != 501) {
        alert(
          'Não foi possível criar a configuração do alerta, favor contatar o suporte do Compulog',
        )
      }
    }

    setCarregandoSMS(false)
  }

  const getOpcoesChegadaVisualizada = () => {
    const opcoes: SelectItemProps[] = [
      { label: 'Sim', value: 'true' },
      { label: 'Não', value: 'false' },
      { label: 'Ambas', value: 'null' },
    ]

    setSelectOpcoesChegadaVisualizada(opcoes)
  }

  const pesquisaListaChegadas = async (filtros: IFormListaChegadaFilter) => {
    const numHorasIntervalo: number = filtros.dataFinalMoment.diff(
      filtros.dataInicialMoment,
      'hours',
    )

    if (numHorasIntervalo / 24 > intervaloMaximoDias) {
      alert(
        `O intervalo entre a data inicial e data final deve ser de no máximo ${intervaloMaximoDias} dias`,
      )
    } else if (!carregandoPesquisa) {
      setCarregandoPesquisa(true)

      filtros.dataInicial = filtros.dataInicialMoment.format(
        'YYYY-MM-DD HH:mm:ss',
      )

      filtros.dataFinal = filtros.dataFinalMoment.format('YYYY-MM-DD HH:mm:ss')

      if (filtros.visualizadoString !== 'null') {
        filtros.visualizado = filtros.visualizadoString === 'true'
      }

      if (filtros.placas && filtros.placas.length > 0) {
        const cdsVeiculos: number[] = filtros.placas.map((cdVeiculo) =>
          window.parseInt(cdVeiculo),
        )

        filtros.placas = veiculos
          .filter((veiculo) => cdsVeiculos.includes(veiculo.id))
          .map((veiculo) => veiculo.placa)
      }

      try {
        const { data } = await WsDocasService.listaChegadas.buscaChegadas(
          ID_COMPONENTE.DOCAS,
          filtros,
        )

        if (data.items) {
          setListaChegadas(data.items)

          setCdIntegracaoCameraPlacaParaAtualizar(undefined)
          setVeiculoAtualizado(undefined)
          setImagens(undefined)

          // const imagemUltimaChegada =
          //   data.items.length > 0 ? data.items[0].imagens : undefined

          // setImagemUltimaChegada(imagemUltimaChegada)

          // if (!restauracaoImagemEmAndamento) {
          //   setImagem(imagemUltimaChegada)
          // }
        }
      } catch (e) {
        alert(
          'Não foram encontradas chegadas com os parâmetros de pesquisa informados',
        )
      }

      setCarregandoPesquisa(false)
    }
  }

  const mostraImagens = async (cdIntegracaoCameraPlaca: number) => {
    setCarregandoImagens(true)

    await visualizaChegada(cdIntegracaoCameraPlaca)
    await buscaImagens(cdIntegracaoCameraPlaca)

    setCarregandoImagens(false)

    // if (chegada.imagens) {
    //   setImagens(chegada.imagens)

    //   if (restauracaoImagemEmAndamento) {
    //     window.clearTimeout(restauracaoImagemEmAndamento)
    //   }

    //   setRestauracaoImagemEmAndamento(
    //     window.setTimeout(() => {
    //       setImagem(imagemUltimaChegada)
    //       setRestauracaoImagemEmAndamento(undefined)
    //     }, tempoMsAtualizacao),
    //   )
    // } else {
    //   alert('A chegada selecionada não possui imagem')
    // }
  }

  const buscaImagens = async (cdIntegracaoCameraPlaca: number) => {
    const { data } = await WsDocasService.listaChegadas.buscaImagens(
      ID_COMPONENTE.DOCAS,
      cdIntegracaoCameraPlaca,
    )

    if (data.items) {
      setImagens(data.items)
    }
  }

  const visualizaChegada = async (cdIntegracaoCameraPlaca: number) => {
    await WsDocasService.listaChegadas.visualizaChegada(
      ID_COMPONENTE.DOCAS,
      cdIntegracaoCameraPlaca,
    )

    listaChegadas.find(
      (chegada) => chegada.cdIntegracaoCameraPlaca == cdIntegracaoCameraPlaca,
    )!.visualizado = true
    setListaChegadas(listaChegadas)
  }

  const descartaChegada = async (cdIntegracaoCameraPlaca: number) => {
    setListaChegadas(
      listaChegadas.filter(
        (chegada) =>
          chegada.cdIntegracaoCameraPlaca !== cdIntegracaoCameraPlaca,
      ),
    )

    await WsDocasService.listaChegadas.descartaChegada(
      ID_COMPONENTE.DOCAS,
      cdIntegracaoCameraPlaca,
    )
  }

  const processaAtualizacaoAutomatica = async () => {
    setCarregandoAtualizacaoAutomatica(true)

    try {
      const dataFinal: moment.Moment = moment()
      const dataInicial: moment.Moment = moment().subtract(
        segundosNoPassadoParaDataInicial,
        'seconds',
      )

      const filtros: IFormListaChegadaFilter = {
        dataInicialMoment: dataInicial,
        dataFinalMoment: dataFinal,
        dataInicial: dataInicial.format('YYYY-MM-DD HH:mm:ss'),
        dataFinal: dataFinal.format('YYYY-MM-DD HH:mm:ss'),
        visualizadoString: 'null',
      }

      const { data } = await WsDocasService.listaChegadas.buscaChegadas(
        ID_COMPONENTE.DOCAS,
        filtros,
      )

      if (data.items) {
        setListaChegadas(data.items)

        setUltimaAtualizacao(dataFinal.format('HH:mm:ss'))
        setCdIntegracaoCameraPlacaParaAtualizar(undefined)
        setVeiculoAtualizado(undefined)
      }
    } catch (e) {
      window.console.error(e)
    }

    if (atualizacaoAutomatica) {
      const idTimeout: number = window.setTimeout(
        () => processaAtualizacaoAutomatica(),
        segundosEntreRequisicoes * 1000,
      )

      setIdTimeout(idTimeout)
    }

    setCarregandoAtualizacaoAutomatica(false)
  }

  useEffect(() => {
    if (atualizacaoAutomatica) {
      processaAtualizacaoAutomatica()
    } else if (idTimeout !== undefined) {
      window.clearTimeout(idTimeout)
      setIdTimeout(undefined)
    }
  }, [atualizacaoAutomatica])

  const ativaOuDesativaAtualizacaoAutomatica = () => {
    if (atualizacaoAutomatica) {
      setUltimaAtualizacao(undefined)
    }

    setAtualizacaoAutomatica(!atualizacaoAutomatica)
  }
  const ativaOuDesativaSMS = async () => {
    setCarregandoSMS(true)

    configuracaoSMS.ativo = !configuracaoSMS.ativo
    setConfiguracaoSMS(configuracaoSMS)

    const { data } = await WsDocasService.sms.updateConfiguracao(
      ID_COMPONENTE.DOCAS,
      configuracaoSMS,
    )

    if (data.statusCode != 501) {
      alert(
        'Não foi possível atualizar a configuração do alerta, favor contatar o suporte do Compulog',
      )
    }

    setCarregandoSMS(false)
  }

  const preparaAtualizacaoPlaca = (cdIntegracaoCameraPlaca: number) => {
    setCdIntegracaoCameraPlacaParaAtualizar(cdIntegracaoCameraPlaca)
  }

  const atualizaPlaca = async () => {
    try {
      if (cdIntegracaoCameraPlacaParaAtualizar && veiculoAtualizado) {
        const dadosAtualizacao: IAtualizacaoPlaca = {
          cdIntegracaoCameraPlaca: cdIntegracaoCameraPlacaParaAtualizar,
          cdVeiculo: veiculoAtualizado.id,
          placa: veiculoAtualizado.placa,
        }
        const { data } = await WsDocasService.listaChegadas.atualizaPlaca(
          ID_COMPONENTE.DOCAS,
          dadosAtualizacao,
        )

        const chegada: IChegada = listaChegadas.find(
          (_chegada) =>
            _chegada.cdIntegracaoCameraPlaca ===
            cdIntegracaoCameraPlacaParaAtualizar,
        )!
        chegada.placaVeiculo = dadosAtualizacao.placa
        chegada.tipoOperacao = data.tipoOperacao
        chegada.armazem = data.armazem

        setListaChegadas(listaChegadas)
      }
    } catch (e) {
      console.error(e)

      alert(
        'Ocorreu um erro ao atualizar a placa, favor contatar o suporte do Compulog',
      )
    }

    setCdIntegracaoCameraPlacaParaAtualizar(undefined)
    setVeiculoAtualizado(undefined)
  }

  const selecionaVeiculo = (cdVeiculo: number) => {
    setVeiculoAtualizado(veiculos.find((veiculo) => veiculo.id === cdVeiculo))
  }

  const ajustaPlaca = (
    placa: string,
    setPlaca: Dispatch<SetStateAction<string | undefined>>,
  ) => {
    setPlaca(
      placa
        .replace(/[^a-zA-Z0-9*]/g, '') //Pode ter letras, números e asterisco
        .substring(0, 10) //Deve ter no máximo 10 caracteres, considerando o padrão Mercosul
        .toUpperCase(), //Deve ter letras maiúsculas
    )
  }

  const mostraPlaca = (placa: string, chegada: IChegada) => {
    return cdIntegracaoCameraPlacaParaAtualizar ===
      chegada.cdIntegracaoCameraPlaca ? (
      <>
        <SelectFieldAnt
          methods={hookFormAtualizacaoPlaca}
          scope="form-atualizacao-placa"
          label=""
          name="novaPlaca"
          items={selectVeiculoItens}
          showSearch={true}
          searchValue={placaAtualizada}
          onSearch={(value: string) => ajustaPlaca(value, setPlacaAtualizada)}
          onChangeValue={(value: string) => {
            selecionaVeiculo(window.parseInt(value))
            setPlacaAtualizada(undefined)
          }}
        />
        <div
          style={{ cursor: 'pointer', textAlign: 'center', marginTop: '-20px' }}
          title="Confirmar"
          onClick={() => atualizaPlaca()}
        >
          <CheckOutlined />
        </div>
      </>
    ) : (
      <>{placa}</>
    )
  }

  return (
    <>
      <Form
        onFinish={pesquisaListaChegadas}
        layout="vertical"
        initialValues={{
          dataInicialMoment: moment([
            today.getFullYear(),
            today.getMonth(),
            today.getDate(),
            0,
            0,
            0,
          ]),
          dataFinalMoment: moment([
            today.getFullYear(),
            today.getMonth(),
            today.getDate(),
            23,
            59,
            59,
          ]),
          visualizadoString: 'false',
        }}
      >
        <PageHeader
          ghost={false}
          title={'Lista de Chegadas'}
          extra={[
            <>
              {ultimaAtualizacao ? (
                <span style={{ marginRight: '10px' }}>
                  Última atualização em {ultimaAtualizacao}
                </span>
              ) : null}
            </>,
            <Switch
              key="atualizacaoAutomatica"
              checkedChildren={
                <span style={cssSwitchLabel}>Atualização Automática</span>
              }
              unCheckedChildren={
                <span style={cssSwitchLabel}>Atualização Automática</span>
              }
              checked={atualizacaoAutomatica}
              onClick={() => ativaOuDesativaAtualizacaoAutomatica()}
              loading={carregandoAtualizacaoAutomatica}
              style={{ height: '32px', top: '-2px' }}
              disabled={selectVeiculoItens.length === 0 || carregandoPesquisa}
            />,
            // <Switch
            //   key="configuracaoSMS"
            //   checkedChildren={
            //     <span style={cssSwitchLabel}>SMS Ativado</span>
            //   }
            //   unCheckedChildren={
            //     <span style={cssSwitchLabel}>SMS Desativado</span>
            //   }
            //   checked={configuracaoSMS?.ativo}
            //   onClick={() => ativaOuDesativaSMS()}
            //   loading={carregandoSMS}
            //   style={{ height: '32px', top: '-2px' }}
            //   disabled={selectVeiculoItens.length === 0}
            // />,
            <Button
              key="pesquisaListaChegadas"
              type="primary"
              htmlType="submit"
              loading={carregandoPesquisa}
              disabled={
                selectVeiculoItens.length === 0 || atualizacaoAutomatica
              }
            >
              Pesquisar
            </Button>,
          ]}
        >
          {/* <Row justify="space-between">
            <div
              style={{
                margin: '10px',
              }}
            >
              <p>
                Para ocorrer a referência da macro ENTRADA NO ESTACIONAMENTO, o
                agendamento deve existir antes da chegada do veículo ou antes de
                correção de placa
              </p>
            </div>
          </Row> */}
          <Skeleton loading={selectVeiculoItens.length === 0} active>
            <Row gutter={16}>
              <Col span={8}>
                <DateSelector
                  name="dataInicialMoment"
                  label="Data Inicial:"
                  showTime={true}
                  rules={[{ required: true, message: 'Campo obrigatório' }]}
                  disabled={atualizacaoAutomatica}
                />
              </Col>

              <Col span={8}>
                <DateSelector
                  name="dataFinalMoment"
                  label="Data Final:"
                  showTime={true}
                  rules={[{ required: true, message: 'Campo obrigatório' }]}
                  disabled={atualizacaoAutomatica}
                />
              </Col>

              <Col span={8}>
                <SelectFieldAnt
                  methods={hookForm}
                  scope="form-lista-chegadas"
                  label="Apenas Chegadas Visualizadas:"
                  name="visualizadoString"
                  items={selectOpcoesChegadaVisualizada}
                  disabled={atualizacaoAutomatica}
                  rules={[{ required: true, message: 'Campo obrigatório' }]}
                />
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <SelectFieldAnt
                  methods={hookForm}
                  scope="form-lista-chegadas"
                  label="Placas Cadastradas no Compulog:"
                  name="placas"
                  items={selectVeiculoItens}
                  showSearch={true}
                  searchValue={placaCadastrada}
                  onSearch={(value: string) =>
                    ajustaPlaca(value, setPlacaCadastrada)
                  }
                  onChangeValue={(value: string) =>
                    setPlacaCadastrada(undefined)
                  }
                  mode="multiple"
                  disabled={atualizacaoAutomatica}
                />
              </Col>

              <Col span={8}>
                <Form.Item name="tipoOperacao" label="Tipo de Operação:">
                  <Input type="text" />
                </Form.Item>
              </Col>

              <Col span={8}>
                <SelectFieldAnt
                  methods={hookForm}
                  scope="form-lista-chegadas"
                  label="Armazéns:"
                  name="armazens"
                  items={selectArmazemItens}
                  showSearch={true}
                  mode="multiple"
                  disabled={atualizacaoAutomatica}
                />
              </Col>
            </Row>
          </Skeleton>
        </PageHeader>
      </Form>
      <Row>
        <Col span={imagens || carregandoImagens ? 14 : 24}>
          <Skeleton loading={selectVeiculoItens.length === 0} active>
            <Table
              pagination={{ position: ['bottomRight'] }}
              scroll={{ y: 400 }}
              columns={[
                {
                  title: '',
                  key: 'cdIntegracaoCameraPlaca',
                  dataIndex: 'cdIntegracaoCameraPlaca',
                  width: '95px',
                  render: (cdIntegracaoCameraPlaca: number) => (
                    <>
                      <span
                        style={{ cursor: 'pointer' }}
                        title="Atualizar placa"
                        onClick={() =>
                          preparaAtualizacaoPlaca(cdIntegracaoCameraPlaca)
                        }
                      >
                        <EditOutlined />
                      </span>

                      <span
                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                        title="Ver imagens"
                        onClick={() => mostraImagens(cdIntegracaoCameraPlaca)}
                      >
                        <EyeOutlined />
                      </span>

                      <span
                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                        title="Descartar"
                        onClick={() => descartaChegada(cdIntegracaoCameraPlaca)}
                      >
                        <DeleteOutlined />
                      </span>
                    </>
                  ),
                },
                {
                  title: 'Placa',
                  key: 'placaVeiculo',
                  dataIndex: 'placaVeiculo',
                  width: '135px',
                  render: (placa: string, chegada: IChegada) =>
                    mostraPlaca(placa, chegada),
                },
                {
                  title: 'Data/Hora',
                  key: 'dataHoraChegadaString',
                  dataIndex: 'dataHoraChegadaString',
                  width: '165px',
                },
                {
                  title: 'Transportadora',
                  key: 'nomeTransportadora',
                  dataIndex: 'nomeTransportadora',
                  width: '140px',
                },
                {
                  title: 'Agendamento',
                  key: 'agendamento',
                  dataIndex: 'agendamento',
                  width: '170px',
                },
                {
                  title: 'Visualizada',
                  key: 'visualizado',
                  dataIndex: 'visualizado',
                  render: (visualizado: boolean) =>
                    visualizado ? 'Sim' : 'Não',
                  width: '105px',
                },
                {
                  title: 'Tipo de Operação',
                  key: 'tipoOperacao',
                  dataIndex: 'tipoOperacao',
                  width: '145px',
                },
                {
                  title: 'Armazém',
                  key: 'armazem',
                  dataIndex: 'armazem',
                  width: '115px',
                },
              ]}
              dataSource={listaChegadas}
              // rowClassName={(chegada: IChegada) =>
              //   chegada.possuiAgendamentoFuturoProximo
              //     ? 'agendamentoFuturoProximo'
              //     : chegada.cdAgendamentoDocasHorario
              //     ? 'agendamentoFuturoDistante'
              //     : 'semAgendamento'
              // }
            />
          </Skeleton>
        </Col>

        {imagens || carregandoImagens ? (
          <Col span={10} style={{ textAlign: 'center' }}>
            {imagens || carregandoImagens ? (
              !imagens || carregandoImagens ? (
                <Spin size="large" style={{ marginTop: '40%' }} />
              ) : (
                <>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <span
                        style={{
                          cursor: 'pointer',
                          marginLeft: '90%',
                        }}
                        title="Fechar"
                        onClick={() => setImagens(undefined)}
                      >
                        <CloseOutlined />
                      </span>

                      <div style={{ fontWeight: 'bold' }}>
                        Imagem original:
                        <div style={{ marginTop: '10px' }}>
                          <img
                            src={imagens[0]}
                            style={{ maxHeight: '300px' }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: '20px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <div>
                        {imagens[1] ? (
                          <>
                            <div style={{ fontWeight: 'bold' }}>
                              Placa ampliada (resolução baixa):
                            </div>
                            <div style={{ marginTop: '10px' }}>
                              <img
                                src={imagens[1]}
                                style={{ maxHeight: '300px' }}
                              />
                            </div>
                          </>
                        ) : (
                          <div style={{ fontWeight: 'bold' }}>
                            A câmera não capturou a foto da placa
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </>
              )
            ) : null}
          </Col>
        ) : null}
      </Row>
    </>
  )
}

export default ModalListaChegadas
